module.exports = __webpack_public_path__ + "static/media/medium-placas.4a6dbe4c.png";